export enum ReportCategory {
  MASTER_TAX_PLAN = 'MASTER_TAX_PLAN',
  MASTER_FINANCIAL_PLAN = 'MASTER_FINANCIAL_PLAN',
  REDTAIL_DOCUMENT = 'REDTAIL_DOCUMENT',
}

export interface Report {
  id: string;
  title: string;
  category: string;
  description: string | null;
  src: string | null;
  redtailId: number;
  deleted: boolean;
  visible: boolean;
  createdAt: string;
  updatedAt: string;
}
